<template>
  <div class="newsDetailContainer">
    <div class="mainContainer">
      <div class="headerTitle">
        <div v-preventReClick class="leftReturn" @click="hclose">
          <!--  <img src="" alt=""> -->
          <i class="el-icon-back" />
          <span>返回列表</span>
        </div>
        <div class="titleMain">
          <span>{{ title }}</span>
        </div>
        <div class="rightReturn" />
      </div>
      <div class="secondTitle">{{ publishTime }}</div>
      <!-- <div class="imgContaienr">
        <img src="../assets/img/newsimg.png" alt="" />
      </div> -->
      <div class="contentMain" v-html="content">
        <!-- <div class="top">
          <span>
            以“镇赶集日”为契机，在人流量大的街边，禁毒社工和志愿者们一起通过发放禁毒宣传资料、讲解相关法律法规、展示新型毒品模型、以通俗易懂的语言
            耐心解答禁毒知识等方式，引导他们正确认识毒品危害，选择健康的生活方式，从而远离毒品侵害。期间发放宣传册600余份，受教育群众达2000人，扩大了
            基层群众的禁毒知识覆盖面，提高了群众的知晓率。
            派出所民警胡涛分别从“毒品是什么？毒品长啥样？毒品有多坏？我该怎么做？”四个板块结合真实案例，为1000余名师生进行了详细的讲解，尤其针对青
            少年好奇心强、辨别是非能力弱，抵制毒品侵袭心理防线脆弱等特点，详细讲解了新型毒品冰毒、摇头丸、K粉的特征，让学生们对毒品有了更清晰的认识。同
            时，呼吁广大师生要以血的教训、铁的事实为诫，提高思想警惕，自觉养成健康向上的生活习惯，自觉远离毒品、拒绝毒品。活动期间发放禁毒宣传展板5块，
            资料1000余份。本次禁毒宣传活动，进一步强化了镇区群众和师生的禁毒意识和参与禁毒工作的积极性，为建设无毒镇区奠定了坚实的基础。</span
          >
        </div>
        <div class="bottom">
          以“镇赶集日”为契机，在人流量大的街边，禁毒社工和志愿者们一起通过发放禁毒宣传资料、讲解相关法律法规、展示新型毒品模型、以通俗易懂的语言
          耐心解答禁毒知识等方式，引导他们正确认识毒品危害，选择健康的生活方式，从而远离毒品侵害。期间发放宣传册600余份，受教育群众达2000人，扩大了
          基层群众的禁毒知识覆盖面，提高了群众的知晓率。
          派出所民警胡涛分别从“毒品是什么？毒品长啥样？毒品有多坏？我该怎么做？”四个板块结合真实案例，为1000余名师生进行了详细的讲解，尤其针对青
          少年好奇心强、辨别是非能力弱，抵制毒品侵袭心理防线脆弱等特点，详细讲解了新型毒品冰毒、摇头丸、K粉的特征，让学生们对毒品有了更清晰的认识。同
          时，呼吁广大师生要以血的教训、铁的事实为诫，提高思想警惕，自觉养成健康向上的生活习惯，自觉远离毒品、拒绝毒品。活动期间发放禁毒宣传展板5块，
          资料1000余份。本次禁毒宣传活动，进一步强化了镇区群众和师生的禁毒意识和参与禁毒工作的积极性，为建设无毒镇区奠定了坚实的基础。
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsDetail } from '@/assets/js/home.js'
export default {
  name: '',
  props: ['newsCentralDetailName', 'newsCentralDetailID'],
  data() {
    return {
      title: '',
      content: '',
      picture: '',
      publishTime: '',
      contentAbstract: ''
    }
  },
  mounted() {
    getNewsDetail(this.newsCentralDetailID).then(res => {
      if (res.status == 200) {
        this.title = res.data.data.title
        this.content = res.data.data.content
        this.picture = res.data.data.picture
        this.publishTime = res.data.data.publishTime
        this.contentAbstract = res.data.data.contentAbstract
      }
    })
  },
  methods: {
    hclose() {
      if (this.newsCentralDetailName == '详情') {
        this.$parent.navtab6 = false
        this.$parent.navtab4 = true
        this.$parent.navtab1 = false
      } else {
        this.$parent.navtab6 = false
        this.$parent.navtab4 = false
        this.$parent.navtab1 = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.newsDetailContainer {
  height: calc(100% - 20px);
  //overflow-y: auto;
  // overflow-x: hidden;
  // background-color: chocolate;
  box-shadow:  0 0  5px #e3e3e3;
  margin-bottom: 15px;
  border-radius: 5px;
  .mainContainer {
    //width: 1226px;
    margin: 0 auto;
    padding-top: 40px;

    .headerTitle {
      display: flex;
      justify-content: space-between;
      .leftReturn {
        margin-left: 10px;
        width: 150px;
        height: 65px;
        // border: 3px solid #2878ff;
        border-radius: 2px;
        //margin-right: 100px;
        padding: 25px 0 10px 20px;
        display: flex;
        cursor: pointer;
        &:hover,
        &:active {
          color: #2878ff;
        }
        i {
          font-size: 22px;
        }
      }
      .rightReturn {
        width: 150px;
        height: 65px;
      }
      .titleMain {
        margin-top: 18px;
        //width: 717px;
        height: 32px;
        font-size: 23px;
        font-family: "PingFangSC-Medium, PingFang SC";
        font-weight: 500;
        color: #434343;
        line-height: 32px;
      }
    }
    .secondTitle {
      margin: 0 auto;
      width: 138px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #434343;
      line-height: 20px;
      margin-top: 10px;
    }
    .imgContaienr {
      width: 100%;
      display: flex;
      justify-content: center;
      img {
        margin: 30px auto;
      }
    }
    .contentMain {
      margin: 0 auto;
      width: 976px;
      font-size: 14px;
      font-family: "PingFangSC-Regular, PingFang SC";
      font-weight: 400;
      color: #434343;
      line-height: 30px;
      margin-bottom: 384px;
      text-indent: 28px;
    }
  }
}
</style>
